module.exports = require("./lib/_stream_passthrough.js")



//////////////////
// WEBPACK FOOTER
// /home/backend/NasheDelo/WebLombard/client/~/readable-stream/passthrough.js
// module id = ../../../../readable-stream/passthrough.js
// module chunks = 3